import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import type { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

import { PACKAGE_UTILIZATION_EXPECTATIONS_AUTO_COMPLETE_QUERY_KEY } from './useAutoCompletePackage';
import { PACKAGE_UTILIZATION_EXPECTATIONS_QUERY_KEY } from './useExpectations';
import { PACKAGE_UTILIZATION_REPORT_QUERY_KEY } from './usePackageUtilization';

export default function useDeleteExpectation(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteExpectation = (expectationId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`/package-utilization-expectations/${expectationId}/`);
  };

  return useMutation(deleteExpectation, {
    onSuccess: () => {
      queryClient.invalidateQueries([PACKAGE_UTILIZATION_EXPECTATIONS_QUERY_KEY]);
      queryClient.invalidateQueries([PACKAGE_UTILIZATION_EXPECTATIONS_AUTO_COMPLETE_QUERY_KEY]);
      queryClient.invalidateQueries([PACKAGE_UTILIZATION_REPORT_QUERY_KEY]);
    },
  });
}
